import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";

import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { SuperAdminService } from "src/app/super-admin.service";
import { EditInvoiceComponent } from "../edit-invoice/edit-invoice.component";
import { AddInvoiceComponent } from "../add-invoice/add-invoice.component";
import { map, startWith } from "rxjs/operators";
@Component({
  selector: "app-edit-tracker",
  templateUrl: "./edit-tracker.component.html",
  styleUrls: ["./edit-tracker.component.css"],
})
export class EditTrackerComponent {
  today = new Date().toISOString().split("T")[0];
  yesterday = new Date(Date.now() - 86400000).toISOString().split("T")[0];

  multipletrips = [];
  actualbalance: any = 0;
  multipleTrips = [];
  tripIDS = [];
  uniqueRes: any = [];
  receipt: any[];
  tripId: any;
  filterdOptions = [];
  vehicles = [];
  DriverNumber;
  vehiclesNumber = [];
  vehicleType;
  vehicleTypesNames = [];
  totalhour;
  isRoleSuperVisor = false;
  userroleid;
  userSessionData;
  trackerId: string;
  particlarLR: any;
  displayedColumns = [
    "noOfArticle",
    "invoiceNo",
    "customerName",
    "invoiceValue",
    "weight",
    "pod",
  ];
  options: string[] = ["One", "Two", "Three"];
  filteredVehicleTypes: Observable<string[]>;
  filteredVehicleRoadPermit: Observable<string[]>;
  filteredConsignorName: Observable<string[]>;
  filteredVehicleNo: Observable<string[]>;
  filteredDriverName: Observable<string[]>;
  filteredDriverNumber: Observable<string[]>;

  editLR = new FormGroup({
    supervisorname: new FormControl(""),
    clientList: new FormControl(""),
    date: new FormControl<string | null>(null, Validators.required),
    VehicleNo: new FormControl("", Validators.required),
    vehicleType: new FormControl("", Validators.required),
    from: new FormControl("", Validators.required),
    to: new FormControl("", Validators.required),
    POD: new FormControl(""),
    fixAdhoc: new FormControl(""),
    customerName: new FormControl(""),
    loadingSlipAttchment: new FormControl(""),
    loadingSlipAttchmentBack: new FormControl(""),
    InvoiceNo: new FormControl(""),
    InvoiceValue: new FormControl(""),
    Weight: new FormControl(""),
    NoofArticle: new FormControl(""),
    startmeterReading: new FormControl(""),
    endmeterReading: new FormControl(""),
    tripSDate: new FormControl(""),
    tripEDate: new FormControl(""),
    outtime: new FormControl(""),
    INtime: new FormControl(""),
    noofTools: new FormControl("", Validators.pattern("^[0-9]*$")),
    tooltaxPaid: new FormControl("", Validators.pattern("^[0-9]*$")),
    updownkm: new FormControl(""),
    extrahour: new FormControl("", Validators.pattern("^[0-9]*$")),
    advance: new FormControl("", Validators.pattern("^[0-9]*$")),
    balance: new FormControl(""),
    balancePaid: new FormControl("", Validators.pattern("^[0-9]*$")),
    vehicleRate: new FormControl("", Validators.pattern("^[0-9]*$")),
    totalhour: new FormControl<number | null>(null),
    otherPayment: new FormControl("", Validators.pattern("^[0-9]*$")),
    TDS: new FormControl("", Validators.pattern("^[0-9]*$")),
    munsipalAmount: new FormControl("", Validators.pattern("^[0-9]*$")),
    finalAmount: new FormControl("", Validators.pattern("^[0-9]*$")),
    otherPaymentDescription: new FormControl(""),
    DLY: new FormControl(""),
    orderId: new FormControl(""),
  });

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private superAdminService: SuperAdminService,
    private sanitizer: DomSanitizer
  ) {}
  ngOnInit(): void {
    this.trackerId = this.route.snapshot.paramMap.get("id");
    if (this.trackerId) {
      this.getLRDetail(this.trackerId);
      ["tripSDate", "tripEDate", "outtime", "INtime"].forEach((field) => {
        this.editLR
          .get(field)
          ?.valueChanges.subscribe(() => this.calculateTotalHours());
      });
    }

    this.userSessionData = JSON.parse(
      sessionStorage.getItem("userSession") || "{}"
    );
    this.userroleid = this.userSessionData.user_role_id?.[0];
    this.isRoleSuperVisor = this.userroleid === 2 ? true : false;

    console.log("isRoleSuperVisor", this.isRoleSuperVisor);
    if (!this.isRoleSuperVisor) {
      this.editLR.controls.supervisorname.disable();
    }

    if (this.isRoleSuperVisor) {
      this.editLR.get("date")?.setValidators([Validators.required]);
      this.editLR.get("date")?.updateValueAndValidity();
    }

    this.getSuperVisorName();
    this.getVehicleDetails();
    this.getVehicleType();
    this.getClientList();
  }

  get ff() {
    return this.editLR.controls;
  }

  // Fetch tracker details and patch form
  getLRDetail(trackerId: string): void {
    if (!trackerId) return;

    this.superAdminService.getTrackerById(trackerId).subscribe({
      next: (res: any) => {
        if (!res.status) {
          this.toastr.error(res.message || "Error fetching tracker");
          return;
        }

        const tracker = res.data;
        this.particlarLR = tracker;

        // Extract date and time correctly
        const tripSDate = tracker.tripStartDate
          ? tracker.tripStartDate.split("T")[0]
          : "";
        const tripEDate = tracker.tripEndDate
          ? tracker.tripEndDate.split("T")[0]
          : "";

        const outTime = tracker.out_time ? tracker.out_time.slice(0, 5) : "";
        const inTime = tracker.in_time ? tracker.in_time.slice(0, 5) : "";

        const trackerDate = tracker.date ? tracker.date.split("T")[0] : null;
        this.editLR.patchValue({
          supervisorname: tracker.supervisorId,
          clientList: tracker.clientId,
          date: trackerDate,
          VehicleNo: tracker.vehicle_id,
          vehicleType: tracker.vehicleType,
          from: tracker.from,
          to: tracker.to,
          POD: tracker.POD,
          fixAdhoc: tracker.fixAdhoc,
          tripSDate,
          tripEDate,
          outtime: outTime,
          INtime: inTime,
          startmeterReading: tracker.startmeterReading,
          endmeterReading: tracker.endmeterReading,
          noofTools: tracker.noofTools,
          tooltaxPaid: tracker.tooltaxPaid,
          updownkm: tracker.up_down_km,
          extrahour: tracker.extrahour,
          advance: tracker.advance,
          balance: tracker.balance,
          balancePaid: tracker.balancePaid,
          vehicleRate: tracker.vehicleRate,
          TDS: tracker.TDS,
          munsipalAmount: tracker.munsipalAmount,
          finalAmount: tracker.finalAmount,
          otherPayment: tracker.otherPayment,
          otherPaymentDescription: tracker.otherPaymentDescription,
          DLY: tracker.dly_no,
          orderId: tracker.orderId,
        });

        // Calculate total hours correctly
        if (tripSDate && tripEDate) {
          const startDate = new Date(`${tripSDate}T${outTime || "00:00"}:00`);
          const endDate = new Date(`${tripEDate}T${inTime || "00:00"}:00`);
          const diffHours = Math.abs(
            Math.round(
              (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60)
            )
          );
          this.editLR.patchValue({ totalhour: diffHours });
        }

        // Patch invoice info if exists
        if (tracker.invoice_no?.length) {
          const invoice = tracker.invoice_no[0];
          this.editLR.patchValue({
            InvoiceNo: invoice.id,
            InvoiceValue: invoice.InvoiceValue,
            Weight: invoice.Weight,
            NoofArticle: invoice.NoofArticle,
            customerName: invoice.customerName,
          });
        }
      },
      error: (err) => this.toastr.error("API Error: " + err),
    });
  }
  getSuperVisorName() {
    this.superAdminService.getSuperVisorName().subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          this.superVisor = rawdata;
          //this.dtOptions.data = this.users;
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.error(res.message);
          }
        }
      },
      (error) => {}
    );
  }
  getClientList() {
    this.superAdminService.getClientList().subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          this.clientList = rawdata;
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            if (res.status == 401) {
              this.toastr.error(res.message);
              window.sessionStorage.clear();
              this.router.navigateByUrl("superAuth/login");
            } else {
              this.toastr.success(res.message);
            }
          }
        }
      },
      (error) => {}
    );
  }
  superVisor: any;
  clientList = [];
  getVehicleTypeFromNumber(event: any) {
    this.multipleTrips = [];
    const selectedVehicleNo = event.option.value;

    const vehicle = this.vehicles.find(
      (v) => v.vehicle_no === selectedVehicleNo
    );
    const vehicleType = vehicle ? vehicle.type : "";
    this.multipletrips = this.tripIDS
      .filter((trip) => trip.vehicle_no === selectedVehicleNo)
      .map((trip) => trip.TripID);

    this.multipleTrips = Array.from(
      new Set(this.multipleTrips.concat(this.multipletrips))
    );

    this.editLR.patchValue({ vehicleType });
  }
  updownkm: any = 0;
  onFocusOutendmeterReading(event: any) {
    this.updownkm =
      parseInt(event.target.value) -
      parseInt(this.editLR.get("startmeterReading").value);
    this.editLR.patchValue({
      updownkm: this.updownkm,
    });
  }
  onFocusOutEvent(event: any) {
    this.actualbalance =
      parseInt(this.editLR.get("vehicleRate").value) -
      parseInt(this.editLR.get("advance").value) -
      parseInt(event.target.value);
    this.editLR.patchValue({
      balance: this.actualbalance,
    });
  }
  private formatTime(time: string | null | undefined): string {
    if (!time) return "00:00";
    const parts = time.split(":");
    const hh = parts[0].padStart(2, "0");
    const mm = parts[1] ? parts[1].padStart(2, "0") : "00";
    return `${hh}:${mm}`;
  }
  private calculateTotalHours(): void {
    const sdate = this.editLR.get("tripSDate")?.value;
    const edate = this.editLR.get("tripEDate")?.value;
    const outtime = this.formatTime(this.editLR.get("outtime")?.value);
    const INtime = this.formatTime(this.editLR.get("INtime")?.value);

    if (sdate && edate) {
      const startDate = new Date(`${sdate}T${outtime}:00`);
      const endDate = new Date(`${edate}T${INtime}:00`);

      if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
        const diffHours = Math.round(
          (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60)
        );
        this.editLR.patchValue({ totalhour: diffHours }, { emitEvent: false });
      }
    }
  }

  onFocusOuttripEDate() {
    const sdate = this.editLR.get("tripSDate")?.value;
    const edate = this.editLR.get("tripEDate")?.value;
    const outtime = this.formatTime(this.editLR.get("outtime")?.value);
    const INtime = this.formatTime(this.editLR.get("INtime")?.value);

    if (sdate && edate) {
      const startDate = new Date(`${sdate}T${outtime}:00`);
      const endDate = new Date(`${edate}T${INtime}:00`);

      if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
        const diffHours = Math.round(
          (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60)
        );
        this.editLR.patchValue({ totalhour: diffHours });
      }
    }
  }

  addvalidatorcss(id: string) {
    const el = document.getElementById(id);
    if (el) el.classList.add("validatorcss");
  }

  removevalidatorcss(id: string) {
    const el = document.getElementById(id);
    if (el) el.classList.remove("validatorcss");
  }
  submitLRClicked = false;
  EditTrackerSubmit() {
    this.submitLRClicked = true;

    // Recalculate total hours before validation
    const sdate = this.editLR.get("tripSDate")?.value;
    const edate = this.editLR.get("tripEDate")?.value;
    const outtime = this.editLR.get("outtime")?.value || "00:00";
    const INtime = this.editLR.get("INtime")?.value || "00:00";

    if (sdate && edate) {
      const startDate = new Date(`${sdate}T${outtime}:00`);
      const endDate = new Date(`${edate}T${INtime}:00`);
      const diffHours = Math.abs(
        Math.round((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60))
      );
      this.editLR.patchValue({ totalhour: diffHours });
    }

    if (this.editLR.invalid) {
      Object.keys(this.editLR.controls).forEach((key) => {
        const control = this.editLR.get(key);
      });
      this.toastr.error("Please fill all required fields correctly");
      return;
    }

    if (!this.particlarLR?._id) {
      this.toastr.error("Tracker ID missing!");
      return;
    }

    // Build payload for API
    const payload = {
      _id: this.particlarLR._id,
      clientList: this.editLR.get("clientList").value,
      date: this.editLR.value.date,
      supervisorId: this.editLR.get("supervisorname").value,
      VehicleNo: this.editLR.value.VehicleNo,
      vehicleType: this.editLR.value.vehicleType,
      from: this.editLR.value.from,
      to: this.editLR.value.to,
      fixAdhoc: this.editLR.value.fixAdhoc,
      startmeterReading: this.editLR.value.startmeterReading,
      endmeterReading: this.editLR.value.endmeterReading,
      tripSDate: this.editLR.value.tripSDate,
      tripEDate: this.editLR.value.tripEDate,
      outtime: this.editLR.value.outtime,
      INtime: this.editLR.value.INtime,
      noofTools: this.editLR.value.noofTools,
      tooltaxPaid: this.editLR.value.tooltaxPaid,
      updownkm: this.editLR.value.updownkm,
      totalhour: this.editLR.value.totalhour,
      extrahour: this.editLR.value.extrahour,
      advance: this.editLR.value.advance,
      balance: this.editLR.value.balance,
      balancePaid: this.editLR.value.balancePaid,
      vehicleRate: this.editLR.value.vehicleRate,
      TDS: this.editLR.value.TDS,
      munsipalAmount: this.editLR.value.munsipalAmount,
      finalAmount: this.editLR.value.finalAmount,
      otherPayment: this.editLR.value.otherPayment,
      otherPaymentDescription: this.editLR.value.otherPaymentDescription,
      DLY: this.editLR.value.DLY,
      orderId: this.editLR.value.orderId,
    };

    this.superAdminService.updateTracker(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.toastr.success(res.message || "Tracker updated successfully");
          this.getLRDetail(this.trackerId);
          this.router.navigate(["/superAdmin/lrmanagement/view-tracker"]);
        } else {
          this.toastr.error(res.message || "Failed to update tracker");
        }
      },
      error: (err) =>
        this.toastr.error("Something went wrong while updating tracker"),
    });
  }

  backTo() {
    window.history.back();
  }

  getVehicleType() {
    this.superAdminService.getVehicleType().subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          rawdata.forEach((item) => {
            this.vehicleTypesNames.push(item.vehicletype_name);
          });
          this.filteredVehicleTypes = this.ff.vehicleType.valueChanges.pipe(
            startWith(""),
            map((value) => this._filterVehicleType(value || ""))
          );
          //this.dtOptions.data = this.users;
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.success(res.message);
          }
        }
      },
      (error) => {}
    );
  }

  getVehicleDetails() {
    this.superAdminService.getvehicles().subscribe((res) => {
      if (res.status) {
        this.vehicles = res.data;
        this.vehiclesNumber = this.vehicles.map((v) => v.vehicle_no);
        this.filteredVehicleNo = this.editLR
          .get("VehicleNo")!
          .valueChanges.pipe(
            startWith(""),
            map((val) => this._filterVehicleNo(val || ""))
          );
      }
    });
  }

  private _filterVehicleType(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.vehicleTypesNames.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  private _filterVehicleNo(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.vehiclesNumber.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }
  addnewinv(acc: any) {
    const dialogRef = this.dialog.open(AddInvoiceComponent, {
      panelClass: "addInvoice",
      data: {
        acc,
        getLrDetail: () => this.getLRDetail(this.trackerId),
      },
    });
  }

  editInvoice(invoice: any, trackerId: string): void {
    const dialogRef = this.dialog.open(EditInvoiceComponent, {
      panelClass: "addInvoice",
      data: {
        invoice,
        trackerId,
        getLrDetail: () => this.getLRDetail(this.trackerId),
      },
    });
  }

  onKeyDate(event: any) {
    if (!this.isRoleSuperVisor) {
      this.removevalidatorcss("datectrl");
      return;
    }

    const ctrl = this.editLR.get("date");
    if (!ctrl?.value) return;

    const inputDate = new Date(ctrl.value);
    inputDate.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    if (inputDate < yesterday || inputDate > today) {
      ctrl.setValue(null);
    }

    if (ctrl.invalid) {
      this.addvalidatorcss("datectrl");
    } else {
      this.removevalidatorcss("datectrl");
    }
  }
}
